import { mdiViewGridOutline } from '@mdi/js'
import localStorageSlim from 'localstorage-slim'

const userProfile = localStorageSlim.get('userProfile', { decrypt: true })

const crm = [
  {
    subheader: 'Motoca CRM',
  },
]

if (userProfile?.hierarchical_profile === 'nivel_2') {
  crm.push(
    {
      title: 'Quadros',
      icon: mdiViewGridOutline,
      children: [
        {
          title: 'Cancelados e Pré',
          to: 'crm-board-canceled-pre-dashboard',
          ActiveTabColor: '#0085FF',
          ActiveTabColor2: '#0085FF',
        },
      ],
    },
  )
} else {
  crm.push(
    {
      title: 'Quadros',
      icon: mdiViewGridOutline,
      children: [
        {
          title: 'Cancelados e Pré',
          to: 'crm-kamban',
          ActiveTabColor: '#0085FF',
          ActiveTabColor2: '#0085FF',
        },
      ],
    },
  )
}

export default crm
